import {
	LOGIN_USER_SUCCESS,
	LOGOUT_USER_SUCCESS,
	SELECT_GROUP,
} from '../../constants/actionTypes';

export const loginUserSuccess = ( user ) => ( {
	type: LOGIN_USER_SUCCESS,
	payload: user,
} );

export const logoutUserSuccess = () => ( {
	type: LOGOUT_USER_SUCCESS,
	payload: null,
} );

export const selectGroup = ( group ) => ( {
	type: SELECT_GROUP,
	payload: group,
} );
